import handleCondition from "./handleConditionOnQuestion";
import * as yup from 'yup';
import { isValidPhoneNumber } from "react-phone-number-input/max";

function getYupObjectPerQuestion(form, formData, question, t) {
    var schema = {};
    if ((question.fieldType !== "custom input" && question.fieldType !== "custom variable") && handleCondition(formData, question, form)) {
        switch (question.type) {
            case "string":
                if (question.fieldType === "date") {
                    schema[question.name] = yup.date()
                        .test('date-year-min', t("La date doit se trouver après le 01/01/1026"), function () {
                            const raw = this.originalValue;
                            if (!raw) return true;
                            const year = parseInt(String(raw).split('-')[0], 10);
                            return !isNaN(year) && year >= 1026;
                        })
                        .test('date-year-max', t("La date doit se trouver avant le 01/01/3000"), function () {
                            const raw = this.originalValue;
                            if (!raw) return true;
                            const year = parseInt(String(raw).split('-')[0], 10);
                            return !isNaN(year) && year <= 3000;
                        });
                } else {
                    schema[question.name] = yup.string();
                }
                break;
            case "array":
                schema[question.name] = yup.array();
                break;
            case "number":
                schema[question.name] = yup.number();
                break;
            case "bool":
                schema[question.name] = yup.boolean();
                break;
            default:
                schema[question.name] = yup.mixed();
                break;
        }
        if (question.min && question.fieldType !== "date") {
            schema[question.name] = schema[question.name].min(question.min)
        }
        if (question.max) {
            schema[question.name] = schema[question.name].max(question.max)
        }
        if (!question.readOnly && question.required) {
            schema[question.name] = schema[question.name].required(x => t("Required field", { questionName: question.label }))
        } else {
            schema[question.name] = schema[question.name].nullable()
        }
        if (question.subQuestions) {
            question.subQuestions.forEach(sb => {
                var generatedSchema = getYupObjectPerQuestion(form, formData, sb, t);
                Object.keys(generatedSchema).forEach(key => {
                    schema[key] = generatedSchema[key];
                })
            })
        }
        if (question.fieldType.includes("phone"))  {
            schema[question.name] = schema[question.name].test(
                'phone-validation',
                t("Numéro de téléphone invalide"),
                function(value) {
                    if (!value || value === '') return true;
                    return isValidPhoneNumber(value);
                }
            )
        }
        if (isRegex(question.subfieldType)) {
            schema[question.name] = schema[question.name].test(
                'regex-validation',
                t("Invalid format field") + ` (${question.label || question.name})`,
                function(value) {
                    if (!value || value === '') return true;
                    return new RegExp(question.subfieldType).test(value);
                }
            )
        }
    }
    return schema;
}

function getYupObject(form, formData, t) {
    var schema = {};
    form.forEach(question => {
        var generatedSchema = getYupObjectPerQuestion(form, formData, question, t);
        Object.keys(generatedSchema).forEach(key => {
            schema[key] = generatedSchema[key];
        })
    });
    return yup.object(schema);
}

function isRegex(value) {
    if (value && value.length > 0 && value !== "phone" && value !== "default")
        return new RegExp(value) instanceof RegExp;
    return false;
}

export default getYupObject;